module.exports = __webpack_public_path__ + "img/制御工学3_5_4.2e137b62.png";